export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7410.6c2016b1.jpg";